import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Donate from "./pages/Donate";
import SignUp from "./pages/SignUp";
import Admin from "./pages/Admin";
import Login from './pages/መግቢያ';
import Dashboard from './pages/Dashboard';
import የማህበሩ_አወቃቀር from "./pages/የማህበሩ_አወቃቀር";
import ማህበሩ_የተቋቋመበት_አላማ from "./pages/ማህበሩ_የተቋቋመበት_አላማ";
import የማህበሩ_አባላት from "./pages/የማህበሩ_አባላት";
import መሰረታዊ_መረጃዎች from "./pages/መሰረታዊ_መረጃዎች";
import አድራሻ from "./pages/አድራሻ";
import መግቢያ from "./pages/መግቢያ";
import { useDispatch } from 'react-redux';
import { loginSuccess } from './redux/sessionSlice';
import React, { useEffect } from 'react';

export default function App() {
  
  const dispatch = useDispatch();
  useEffect(() => {
    const userSession = localStorage.getItem('userSession');
    if (userSession) {
      const { user, token } = JSON.parse(userSession);
      dispatch(loginSuccess({ user, token }));
    }
  }, [dispatch]);
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/ስለ_ማህበሩ" element={<About />} />
        <Route exact path="/ክንውን" element={<Events />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/ለግሱ" element={<Donate />} />
        <Route exact path="/signup" element={<SignUp />} />
        <Route exact path="/admin" element={<Admin />} />
        <Route exact path="*" element={<Navigate to={"/"} />} />
        <Route exact path="/የማህበሩ_አወቃቀር" element={<የማህበሩ_አወቃቀር />} />
        <Route exact path="/ማህበሩ_የተቋቋመበት_አላማ" element={<ማህበሩ_የተቋቋመበት_አላማ />} />
        <Route exact path="/የማህበሩ_አባላት" element={<የማህበሩ_አባላት />} />
        <Route exact path="/መሰረታዊ_መረጃዎች" element={<መሰረታዊ_መረጃዎች />} />
        <Route exact path="/አድራሻ" element={<አድራሻ />} />
        <Route exact path="/መግቢያ" element={<መግቢያ />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
